import { render, staticRenderFns } from "./VerifyTwoFA.vue?vue&type=template&id=2367c094&scoped=true&"
import script from "./VerifyTwoFA.vue?vue&type=script&lang=js&"
export * from "./VerifyTwoFA.vue?vue&type=script&lang=js&"
import style0 from "./VerifyTwoFA.vue?vue&type=style&index=0&id=2367c094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2367c094",
  null
  
)

export default component.exports